import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
class Row7 extends Component {
  render() {
    return <Layout {...this.props} type="RowCarousel" />;
  }
}

Row7.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

export default Row7;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Row/Row7.js